// a react-three-fiber scene
import { OrbitControls } from "@react-three/drei";
import { softShadows } from "@react-three/drei";

import React, { useState } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import Model from "./House";
import { Suspense } from "react";

softShadows();

export default function Scene6() {
  return (
    <div style={{ height: "100%" }}>
      <Suspense falllback={null}>
        <Canvas
          draggable
          orthographic
          shadows
          camera={{ position: [-5, 5, -5], zoom: 120, near: -20 }}
        >
          <OrbitControls minPolarAngle={0.6} maxPolarAngle={1} minZoom={60} maxZoom={250} />
          <Suspense falllback={null}>
            <Inner />

            <ambientLight intensity={2}></ambientLight>
          </Suspense>
        </Canvas>
      </Suspense>
    </div>
  );
}

function Inner() {
  let [angle, setAngle] = useState(0);

  useFrame(({ camera }) => {
    let currAngle = camera.rotation.z;
    currAngle = (currAngle + Math.PI) / Math.PI;

    if (angle !== 0 && currAngle > 0 && currAngle <= 0.5) {
      setAngle(0);
    }
    if (angle !== 1 && currAngle > 0.5 && currAngle <= 1) {
      setAngle(1);
    }
    if (angle !== 2 && currAngle > 1 && currAngle <= 1.5) {
      setAngle(2);
    }
    if (angle !== 3 && currAngle > 1.5 && angle <= 2) {
      setAngle(3);
    }
  });
  return (
    <>
      <Model angle={angle}></Model>
    </>
  );
}
